import React from "react";
import logo from "../../../asserts/logo_ptr.png";
import { useNavigate } from "react-router-dom";

const ForgetPassword = () => {
    const navigate = useNavigate();

    return (
        <div className="login-page d-flex justify-content-center align-items-center">
            <div className="content-div d-flex flex-column justify-content-center">
                <div className="text-center">
                    <img src={logo} className="logo" alt="logo" />
                </div>
                <h1 className="forget-t1 mt-4 mb-0">Recover your password</h1>
                <p className="mt-2 forget-t2 mb-0 mt-4"><b>Enter the email</b> that you used <br />when register to recover your password. <br />You will receive a <b>password reset link.</b></p>
                <div className="mt-4">                    
                    <div className="margin-auto w-100-50">
                        <input type="text" className="searchBox w-100" placeholder="User or Email" />
                    </div>
                </div> 
                <div className="d-flex mt-4">
                    <div className="w-100-50 margin-auto">
                        <button className="pointerButton w-100" onClick={() => navigate('/reset-password')}>SEND LINK</button>
                        <p className="text-center login-t1 mt-4" onClick={() => navigate('/login')}>&#60; Back to Login</p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ForgetPassword;